import React, { useState } from "react";
import { DebounceButton } from "../common/DebounceButton";
import { ButtonVariant } from "@amzn/stencil-react-components/button";
import useArb, { useArbHvh } from "../../hooks/use-arb";
import { Col } from "@amzn/stencil-react-components/layout";
import { H4, Text } from "@amzn/stencil-react-components/text";
import { DocUploadFormInputItem, DocUploadsListConfig } from "../../utility/constants/common";
import { SelectOption } from "../../utility/types/common";
import { DOC_UPLOAD_CATEGORIES, DOC_UPLOAD_FORM_INPUT_IDS, DOC_UPLOAD_PAGE_STATE } from "../../utility/enums/common";
import { useDispatch } from "react-redux";
import { setActivePage } from "../../reduxStore/slices/docUploadSlice";
import FormInputSelect from "../common/FormInputSelect";

export const SelectDocumentsType = () => {
  const [docUploadsFields, setDocUploadsFields] = useState(DocUploadsListConfig);
  const [selectedDocCategory, setSelectedDocCategory] = useState<string | null>(null);
  const dispatch = useDispatch();

  const { getMessage } = useArb("HVHChecklistPantherResource");

  const handleSelectChange = (value: SelectOption, fieldId: DOC_UPLOAD_FORM_INPUT_IDS) => {
    setDocUploadsFields(
      docUploadsFields.map((bgInfo) => {
        if (bgInfo.id === fieldId) {
          return { ...bgInfo, value: value.value, hasError: false };
        }

        return bgInfo;
      })
    );

    if (fieldId === DOC_UPLOAD_FORM_INPUT_IDS.SELECT_DOCUMENT_CATEGORY) {
      setSelectedDocCategory(value.value);
    }
  };

  const renderFormItem = (formItem: DocUploadFormInputItem) => {
    switch (formItem.type) {
      case "select":
        if (formItem.id === DOC_UPLOAD_FORM_INPUT_IDS.SELECT_DOCUMENT_ITEM) {
          if (!selectedDocCategory) return <></>;

          return (
            <FormInputSelect
              key={formItem.id}
              inputItem={formItem}
              isSearchable
              filterByCategory={selectedDocCategory}
              onChange={(option: SelectOption) => handleSelectChange(option, formItem.id)}
            />
          );
        }

        return (
          <FormInputSelect
            key={formItem.id}
            inputItem={formItem}
            isSearchable
            onChange={(option: SelectOption) => handleSelectChange(option, formItem.id)}
          />
        );
      default:
        return <></>;
    }
  };

  const validateForm = (): boolean => {
    let isValid = true;

    const _DocUploadsFields = docUploadsFields.map((field) => {
      if (field.required && field.value?.length === 0) {
        // disable show error for selectDocumentItem, if no categories selected yet.
        if (field.id === DOC_UPLOAD_FORM_INPUT_IDS.SELECT_DOCUMENT_ITEM && !selectedDocCategory) {
          return { ...field, hasError: false };
        }

        isValid = false;
        return { ...field, hasError: true };
      }

      return field;
    });

    if (!isValid) setDocUploadsFields(_DocUploadsFields);

    return isValid;
  };

  const handleClickNext = () => {
    if (!validateForm()) return;

    dispatch(setActivePage({ page: DOC_UPLOAD_PAGE_STATE.SELECT_FILE_TO_UPLOAD }));
    // TODO: Need to connect to correct API
  };

  return (
    <Col padding="S300" gridGap="S300">
      <H4>{getMessage("Checklist-docUpload-header", `Upload mandatory documents`)}</H4>
      <Text>
        {getMessage(
          "Checklist-docUpload-description",
          `Please take a moment to review the acceptable documents information and ensure you have the right documents on hand before beginning the process: Click here to see examples of acceptable documents.`
        )}
      </Text>
      {docUploadsFields.map((config) => {
        return (
          <Col key={config.label} gridGap={15}>
            {renderFormItem(config)}
          </Col>
        );
      })}
      <DebounceButton variant={ButtonVariant.Secondary} onClick={handleClickNext}>
        {getMessage("Checklist-Common-Continue", `Continue`)}
      </DebounceButton>
    </Col>
  );
};
